/* tslint:disable */
/* eslint-disable */
/**
 * MetX Workbench
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import * as runtime from '../runtime.js';
/**
 *
 */
export class AccountApi extends runtime.BaseAPI {
    /**
     * Add Account Tag
     */
    async addTagToCurrentAccountRaw(requestParameters, initOverrides) {
        if (requestParameters['tag'] == null) {
            throw new runtime.RequiredError('tag', 'Required parameter "tag" was null or undefined when calling addTagToCurrentAccount().');
        }
        const queryParameters = {};
        if (requestParameters['tag'] != null) {
            queryParameters['tag'] = requestParameters['tag'];
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }
        if (this.configuration && this.configuration.apiKey) {
            queryParameters["access_token"] = await this.configuration.apiKey("access_token"); // APIKeyQuery authentication
        }
        let urlPath = `/api/v2/account/tags/add`;
        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Add Account Tag
     */
    async addTagToCurrentAccount(requestParameters, initOverrides) {
        const response = await this.addTagToCurrentAccountRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Retrieve the account associated with the signed in user. While the user holds business data (authentication and billing information), the account holds the actual program data (profiles, maps, plots, etc).
     * Read Account
     */
    async getAccountOfCurrentUserRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }
        if (this.configuration && this.configuration.apiKey) {
            queryParameters["access_token"] = await this.configuration.apiKey("access_token"); // APIKeyQuery authentication
        }
        let urlPath = `/api/v2/account/current`;
        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Retrieve the account associated with the signed in user. While the user holds business data (authentication and billing information), the account holds the actual program data (profiles, maps, plots, etc).
     * Read Account
     */
    async getAccountOfCurrentUser(initOverrides) {
        const response = await this.getAccountOfCurrentUserRaw(initOverrides);
        return await response.value();
    }
    /**
     * Read Permissions
     */
    async getPermissionsOfCurrentUserRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }
        if (this.configuration && this.configuration.apiKey) {
            queryParameters["access_token"] = await this.configuration.apiKey("access_token"); // APIKeyQuery authentication
        }
        let urlPath = `/api/v2/account/permissions`;
        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Read Permissions
     */
    async getPermissionsOfCurrentUser(initOverrides) {
        const response = await this.getPermissionsOfCurrentUserRaw(initOverrides);
        return await response.value();
    }
    /**
     * Read Account Tags
     */
    async getTagsOfCurrentUserRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }
        if (this.configuration && this.configuration.apiKey) {
            queryParameters["access_token"] = await this.configuration.apiKey("access_token"); // APIKeyQuery authentication
        }
        let urlPath = `/api/v2/account/tags`;
        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Read Account Tags
     */
    async getTagsOfCurrentUser(initOverrides) {
        const response = await this.getTagsOfCurrentUserRaw(initOverrides);
        return await response.value();
    }
    /**
     * Remove Account Tag
     */
    async removeTagFromCurrentAccountRaw(requestParameters, initOverrides) {
        if (requestParameters['tag'] == null) {
            throw new runtime.RequiredError('tag', 'Required parameter "tag" was null or undefined when calling removeTagFromCurrentAccount().');
        }
        const queryParameters = {};
        if (requestParameters['tag'] != null) {
            queryParameters['tag'] = requestParameters['tag'];
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }
        if (this.configuration && this.configuration.apiKey) {
            queryParameters["access_token"] = await this.configuration.apiKey("access_token"); // APIKeyQuery authentication
        }
        let urlPath = `/api/v2/account/tags/delete`;
        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Remove Account Tag
     */
    async removeTagFromCurrentAccount(requestParameters, initOverrides) {
        const response = await this.removeTagFromCurrentAccountRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Rename Account Tag
     */
    async renameTagOfCurrentAccountRaw(requestParameters, initOverrides) {
        if (requestParameters['oldTag'] == null) {
            throw new runtime.RequiredError('oldTag', 'Required parameter "oldTag" was null or undefined when calling renameTagOfCurrentAccount().');
        }
        if (requestParameters['newTag'] == null) {
            throw new runtime.RequiredError('newTag', 'Required parameter "newTag" was null or undefined when calling renameTagOfCurrentAccount().');
        }
        const queryParameters = {};
        if (requestParameters['oldTag'] != null) {
            queryParameters['old_tag'] = requestParameters['oldTag'];
        }
        if (requestParameters['newTag'] != null) {
            queryParameters['new_tag'] = requestParameters['newTag'];
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }
        if (this.configuration && this.configuration.apiKey) {
            queryParameters["access_token"] = await this.configuration.apiKey("access_token"); // APIKeyQuery authentication
        }
        let urlPath = `/api/v2/account/tags/rename`;
        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Rename Account Tag
     */
    async renameTagOfCurrentAccount(requestParameters, initOverrides) {
        const response = await this.renameTagOfCurrentAccountRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Set Active Account Tags
     */
    async setActiveTagsOfCurrentAccountRaw(requestParameters, initOverrides) {
        if (requestParameters['requestBody'] == null) {
            throw new runtime.RequiredError('requestBody', 'Required parameter "requestBody" was null or undefined when calling setActiveTagsOfCurrentAccount().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }
        if (this.configuration && this.configuration.apiKey) {
            queryParameters["access_token"] = await this.configuration.apiKey("access_token"); // APIKeyQuery authentication
        }
        let urlPath = `/api/v2/account/tags/active`;
        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['requestBody'],
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Set Active Account Tags
     */
    async setActiveTagsOfCurrentAccount(requestParameters, initOverrides) {
        const response = await this.setActiveTagsOfCurrentAccountRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Update User Features
     */
    async updateFeaturesOfUserRaw(requestParameters, initOverrides) {
        if (requestParameters['username'] == null) {
            throw new runtime.RequiredError('username', 'Required parameter "username" was null or undefined when calling updateFeaturesOfUser().');
        }
        if (requestParameters['featureInput'] == null) {
            throw new runtime.RequiredError('featureInput', 'Required parameter "featureInput" was null or undefined when calling updateFeaturesOfUser().');
        }
        const queryParameters = {};
        if (requestParameters['username'] != null) {
            queryParameters['username'] = requestParameters['username'];
        }
        if (requestParameters['featureInput'] != null) {
            queryParameters['feature_input'] = requestParameters['featureInput'];
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }
        if (this.configuration && this.configuration.apiKey) {
            queryParameters["access_token"] = await this.configuration.apiKey("access_token"); // APIKeyQuery authentication
        }
        let urlPath = `/api/v2/account/permissions/features`;
        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Update User Features
     */
    async updateFeaturesOfUser(requestParameters, initOverrides) {
        const response = await this.updateFeaturesOfUserRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Retrieve the account associated with the signed in user. While the user holds business data (authentication and billing information), the account holds the actual program data (profiles, maps, plots, etc).
     * Read Account
     */
    async v2GetAccountRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }
        if (this.configuration && this.configuration.apiKey) {
            queryParameters["access_token"] = await this.configuration.apiKey("access_token"); // APIKeyQuery authentication
        }
        let urlPath = `/api/v2/account/`;
        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Retrieve the account associated with the signed in user. While the user holds business data (authentication and billing information), the account holds the actual program data (profiles, maps, plots, etc).
     * Read Account
     */
    async v2GetAccount(initOverrides) {
        const response = await this.v2GetAccountRaw(initOverrides);
        return await response.value();
    }
    /**
     * Retrieve the account associated with the signed in user. While the user holds business data (authentication and billing information), the account holds the actual program data (profiles, maps, plots, etc).
     * Read Slim Account
     */
    async v2GetAccountSlimRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }
        if (this.configuration && this.configuration.apiKey) {
            queryParameters["access_token"] = await this.configuration.apiKey("access_token"); // APIKeyQuery authentication
        }
        let urlPath = `/api/v2/account/slim-account`;
        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Retrieve the account associated with the signed in user. While the user holds business data (authentication and billing information), the account holds the actual program data (profiles, maps, plots, etc).
     * Read Slim Account
     */
    async v2GetAccountSlim(initOverrides) {
        const response = await this.v2GetAccountSlimRaw(initOverrides);
        return await response.value();
    }
    /**
     * Retrieve the account associated with the signed in user. While the user holds business data (authentication and billing information), the account holds the actual program data (profiles, maps, plots, etc).
     * Update Account
     */
    async v2UpdateAccountRaw(requestParameters, initOverrides) {
        if (requestParameters['accountId'] == null) {
            throw new runtime.RequiredError('accountId', 'Required parameter "accountId" was null or undefined when calling v2UpdateAccount().');
        }
        if (requestParameters['accountUpdate'] == null) {
            throw new runtime.RequiredError('accountUpdate', 'Required parameter "accountUpdate" was null or undefined when calling v2UpdateAccount().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }
        if (this.configuration && this.configuration.apiKey) {
            queryParameters["access_token"] = await this.configuration.apiKey("access_token"); // APIKeyQuery authentication
        }
        let urlPath = `/api/v2/account/{account_id}`;
        urlPath = urlPath.replace(`{${"account_id"}}`, encodeURIComponent(String(requestParameters['accountId'])));
        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['accountUpdate'],
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Retrieve the account associated with the signed in user. While the user holds business data (authentication and billing information), the account holds the actual program data (profiles, maps, plots, etc).
     * Update Account
     */
    async v2UpdateAccount(requestParameters, initOverrides) {
        const response = await this.v2UpdateAccountRaw(requestParameters, initOverrides);
        return await response.value();
    }
}
